module.exports = require("@splunk/dashboard-visualizations/Image");